// In the browser: pdf.js with its worker file from the build, and any statement file the person picks (bankCsv.ts holds
// the readers, shared with the email-in worker)
import { readPdfWith, readStatementBytes, type PdfJs, type Read } from "./bankCsv";

export async function readPdf(buf: ArrayBuffer, password?: string): Promise<Read> {
  const pdfjs = await import("pdfjs-dist/legacy/build/pdf.mjs");   // the legacy build: runs on browsers a year or two old too
  const worker = (await import("pdfjs-dist/legacy/build/pdf.worker.min.mjs?url")).default;
  pdfjs.GlobalWorkerOptions.workerSrc = worker;
  return readPdfWith(pdfjs as unknown as PdfJs, buf, password);
}


// any statement file: by its type and content
export async function readStatementFile(f: File, password?: string): Promise<Read> {
  return readStatementBytes(f.name, await f.arrayBuffer(), password, readPdf);
}
